<template>
	<nav class="navbar navbar-expand-lg">
		<div class="container-xl">
			<router-link class="navbar-brand" to="/" exact-active-class="logo-active">
				<img src="../assets/newlogo2-gv.png" alt="DietDiary Logo" height="50" />
			</router-link>
			<button
				ref="toggler"
				class="navbar-toggler collapsed"
				type="button"
				data-bs-toggle="collapse"
				data-bs-target="#navbarNav"
				aria-controls="navbarNav"
				aria-expanded="false"
				aria-label="Toggle navigation">
				<span class="navbar-toggler-icon"></span>
			</button>
			<div class="collapse navbar-collapse" id="navbarNav" ref="navarea">
				<ul class="navbar-nav me-auto mb-2 mb-lg-0 gap-4">
					<li class="nav-item" v-if="hasToken()">
						<router-link
							class="nav-link"
							to="/dashboard"
							exact-active-class="active"
							>Dashboard</router-link
						>
					</li>
					<li class="nav-item" v-if="hasToken()">
						<router-link
							class="nav-link"
							to="/month-view"
							exact-active-class="active"
							>Month View</router-link
						>
					</li>
					<li class="nav-item" v-if="hasToken()">
						<router-link
							class="nav-link"
							to="/meal-plan"
							exact-active-class="active"
							>Meal Plan</router-link
						>
					</li>
					<li class="nav-item" v-if="hasToken()">
						<router-link
							class="nav-link"
							to="/search"
							exact-active-class="active"
							>Search</router-link
						>
					</li>
					<li class="nav-item" v-if="hasToken()">
						<router-link
							class="nav-link"
							to="/profile"
							exact-active-class="active"
							>Profile</router-link
						>
					</li>
					<li class="nav-item" v-if="hasToken()">
						<router-link class="nav-link" to="/subscription">
							Subscription
						</router-link>
					</li>
					<li class="nav-item" v-if="!hasToken()">
						<router-link
							class="nav-link"
							to="/signin"
							exact-active-class="active"
							>Sign in</router-link
						>
					</li>
					<li class="nav-item" v-else>
						<a
							class="nav-link"
							style="cursor: pointer"
							to="#"
							@click.prevent="logout"
							>Logout</a
						>
					</li>
					<li class="nav-item dropdown" v-if="hasToken() && isAdmin">
						<a
							class="nav-link dropdown-toggle"
							href="#"
							id="adminDropdown"
							role="button"
							data-bs-toggle="dropdown"
							aria-expanded="false">
							Admin
						</a>
						<ul class="dropdown-menu" aria-labelledby="adminDropdown">
							<li>
								<router-link class="dropdown-item" to="/admin/users"
									>User Management</router-link
								>
							</li>
							<li>
								<router-link class="dropdown-item" to="/admin/manage-invites"
									>Manage Invitations</router-link
								>
							</li>
							<li>
								<router-link class="dropdown-item" to="/admin/manage-ach"
									>Achievements Admin</router-link
								>
							</li>
							<li>
								<router-link class="dropdown-item" to="/admin/amazon"
									>Manage Amazon Affiliates</router-link
								>
							</li>
						</ul>
					</li>
				</ul>

				<member-select />

				<!-- <div class="d-flex align-items-center" v-if="hasToken()">
					<img alt="coin" src="../assets/coin.png" width="30" />
					<span class="ms-2">{{ userCoins }}</span>
				</div> -->
				<!-- <form role="search" @submit.prevent="searchFood">
					<div class="input-group">
						<input
							class="form-control"
							v-model="search"
							type="search"
							placeholder="Search"
							aria-label="Search" />
						<button type="submit" class="btn btn-primary">
							<i class="bi bi-search"></i>
						</button>
					</div>
				</form> -->
			</div>
		</div>
	</nav>
</template>

<script setup>
	import { RouterLink, useRouter, useRoute } from "vue-router"
	import { ref, watch, computed } from "vue"
	// import Swal from "sweetalert2"
	import { useTokenStore } from "@/stores/token"
	import { useUserStore } from "@/stores/user"
	// import router from "@/router"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	import MemberSelect from "./MemberSelect.vue"

	// const search = ref(null)
	const tokenStore = useTokenStore()
	const { hasToken } = tokenStore
	const userStore = useUserStore()

	// const userCoins = ref(0)
	const router = useRouter()
	const route = useRoute()
	const navarea = ref(null)
	const toggler = ref(null)

	const isAdmin = computed(
		() => tokenStore.getRole && tokenStore.getRole() === "admin"
	)

	// function searchFood() {
	// 	Swal.fire({ icon: "info", title: "Feature needs to be built" })
	// }

	// async function fetchCredits() {
	// 	if (hasToken()) {
	// 		try {
	// 			const response = await fetch("/api/credits", {
	// 				method: "GET",
	// 				headers: {
	// 					Authorization: `Bearer ${tokenStore.token}`,
	// 				},
	// 			})

	// 			if (hasTokenIssue(response)) {
	// 				handleTokenIssue(response)
	// 			} else {
	// 				if (!response.ok) {
	// 					throw new Error("Failed to fetch nutritional summary")
	// 				}
	// 				const data = await response.json()
	// 				userCoins.value = data.credits
	// 			}
	// 		} catch (error) {
	// 			console.error("Error:", error)
	// 		}
	// 	}
	// }

	async function logout() {
		await tokenStore.clearTokens()
		userStore.setUser(null)
		userStore.setActingAsUser(null)
		router.push("/")
	}

	function closeNav() {
		const nav = navarea.value
		if (nav && nav.classList.contains("show")) {
			toggler.value.click()
		}
	}

	async function fetchProfile() {
		try {
			// console.log("CALLING PROFILE")
			const response = await fetchWithAuth("/api/user", {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					// Authorization: `Bearer ${tokenStore.token}`,
				},
			})

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const data = await response.json()
			// console.log(data)
			userStore.setUser(data.user)
			userStore.setActingAsUser(data.actUser)
			// }
		} catch (e) {
			console.log(e)
		}
	}

	watch(
		() => tokenStore.hasToken(),
		(v, ov) => {
			// console.log(v, ov)
			if (v && v != ov) {
				// console.log("IN HERE")
				fetchProfile()
			}
		},
		{ immediate: true }
	)

	watch(
		() => route.fullPath,
		(newPath, oldPath) => {
			if (oldPath && newPath) {
				closeNav()
				// fetchCredits()
			}
		}
	)

	// fetchProfile()
</script>

<style scoped lang="less">
	@import "../assets/colors.less";

	.navbar {
		// position: sticky;
		top: 0;
		z-index: 40;
		width: 100%;
		display: flex;
		justify-content: center;
		background: linear-gradient(
			180deg,
			rgba(4, 17, 15, 0.85),
			rgba(4, 17, 15, 0.6)
		);
		color: @navbar-text-color;
		border-bottom: 1px solid rgba(255, 255, 255, 0.1);
		backdrop-filter: blur(8px);
		-webkit-backdrop-filter: blur(8px);
		box-shadow: none;
		font-weight: 700;

		.navbar-nav {
			gap: 20px; // Add space between nav items
		}

		.nav-link {
			font-size: 18px;
			padding: 10px 15px;
			color: @navbar-text-color;
			border-radius: 5px;
			text-transform: uppercase;
			text-align: center;

			&:hover {
				background-color: @navbar-highlight-color;
				color: white;
			}

			&.active {
				background-color: @color3;
				color: white;
				border-radius: 8px;
			}

			&.show {
				color: white;
			}
		}

		.navbar-toggler {
			border-color: rgba(255, 255, 255, 0.35);
			&:focus {
				box-shadow: 0 0 0 0.15rem rgba(255, 255, 255, 0.25);
			}

			> span.navbar-toggler-icon {
				/* Force white hamburger lines */
				background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255,1)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E");
				background-size: 100% 100%;
			}
		}
	}
</style>
